// extracted by mini-css-extract-plugin
module.exports = {"header":"GivenSection_header__5KQ6L","title":"GivenSection_title__YpeQQ","content":"GivenSection_content__10B2S"};